import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_REQUEST_ACCRUAL_TEMPLATES_BEGIN](state) {
    state.requestAccrualTemplatesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_REQUEST_ACCRUAL_TEMPLATES_SUCCESS](state, requestAccrualTemplates) {
    state.requestAccrualTemplatesGetError = null;
    state.requestAccrualTemplates = requestAccrualTemplates;
    state.requestAccrualTemplatesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_REQUEST_ACCRUAL_TEMPLATES_ERROR](state, err) {
    state.requestAccrualTemplatesGetState = API_STATES.REQUEST_ERROR;
    state.requestAccrualTemplatesGetError = err;
  }
};

export default mutations;